export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/35575a5b6647beb2.gif"